// Generated by purs version 0.13.0
"use strict";
var Data_Functor = require("../Data.Functor/index.js");
var Data_Show = require("../Data.Show/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Ritoppu_Action = require("../Ritoppu.Action/index.js");
var Ritoppu_Model_Creature = require("../Ritoppu.Model.Creature/index.js");
var Ritoppu_Model_Item = require("../Ritoppu.Model.Item/index.js");
var withStyle = function (classes) {
    return function (msg) {
        return Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_(classes) ])([ Halogen_HTML_Core.text(msg) ]);
    };
};
var warn = withStyle("msg -warn");
var info = withStyle("msg -info");
var focus = withStyle("msg -focus");
var div = function (classes) {
    return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(classes) ]);
};
var debug = withStyle("msg -debug");
var critical = withStyle("msg -critical");
var buildMessage = function (msg) {
    return div("log-message")((function () {
        if (msg instanceof Ritoppu_Action.DamageYouM) {
            return [ warn(Ritoppu_Model_Creature.creatureName(msg.value0)), info(" attacks you for "), critical(Data_Show.show(Data_Show.showInt)(msg.value1)), info(" hit points") ];
        };
        if (msg instanceof Ritoppu_Action.DamageYouHarmlessM) {
            return [ warn(Ritoppu_Model_Creature.creatureName(msg.value0)), info(" attacks you but does no damage") ];
        };
        if (msg instanceof Ritoppu_Action.HitAWallM) {
            return [ debug("You hit a wall ") ];
        };
        if (msg instanceof Ritoppu_Action.AttackM) {
            return [ info("You attacked "), warn(Ritoppu_Model_Creature.creatureName(msg.value0)), info(" and did "), warn(Data_Show.show(Data_Show.showInt)(msg.value1)), info(" damage") ];
        };
        if (msg instanceof Ritoppu_Action.AttackHarmlessM) {
            return [ info("You attacked "), critical(Ritoppu_Model_Creature.creatureName(msg.value0)), info(" but did no damage") ];
        };
        if (msg instanceof Ritoppu_Action.AttackKillM) {
            return [ info("You smashed "), critical(Ritoppu_Model_Creature.creatureName(msg.value0)) ];
        };
        if (msg instanceof Ritoppu_Action.PickedUpItem) {
            return [ info("You picked "), focus(Ritoppu_Model_Item.itemName(msg.value0)), info(" up") ];
        };
        if (msg instanceof Ritoppu_Action.NothingToPickUp) {
            return [ debug("You see nothing to pick up") ];
        };
        if (msg instanceof Ritoppu_Action.DropItem) {
            return [ info("You dropped "), focus(Ritoppu_Model_Item.itemName(msg.value0)) ];
        };
        if (msg instanceof Ritoppu_Action.DoNotHave) {
            return [ debug("You don't have this") ];
        };
        if (msg instanceof Ritoppu_Action.FullHealth) {
            return [ debug("You are already at full health") ];
        };
        if (msg instanceof Ritoppu_Action.Healed) {
            return [ info("Your wounds start to feel better!") ];
        };
        if (msg instanceof Ritoppu_Action.DoNotKnowHowToUse) {
            return [ debug("You don't know how to use it") ];
        };
        if (msg instanceof Ritoppu_Action.LightningScrollHitYourself) {
            return [ critical("A lighting hits you") ];
        };
        if (msg instanceof Ritoppu_Action.TargetingOutOfFov) {
            return [ debug("You cannot target a tile outside your field of view.") ];
        };
        if (msg instanceof Ritoppu_Action.FireballExplodes) {
            return [ info("The fireball explodes, burning everything within "), warn(Data_Show.show(Data_Show.showInt)(msg.value0)), info(" tiles!") ];
        };
        if (msg instanceof Ritoppu_Action.BurnSelf) {
            return [ info("You got burned for "), critical(Data_Show.show(Data_Show.showInt)(msg.value0)), info(" hit points.") ];
        };
        if (msg instanceof Ritoppu_Action.BurnM) {
            return [ info("The  "), warn(Ritoppu_Model_Creature.creatureName(msg.value0)), info(" gets burned for "), critical(Data_Show.show(Data_Show.showInt)(msg.value1)), info(" hit points.") ];
        };
        if (msg instanceof Ritoppu_Action.Targeting) {
            return [ debug(msg.value0) ];
        };
        if (msg instanceof Ritoppu_Action.TargetNoEnemy) {
            return [ debug("There is no targetable enemy at that location.") ];
        };
        if (msg instanceof Ritoppu_Action.CastConfusion) {
            return [ info("The eyes of the "), warn(Ritoppu_Model_Creature.creatureName(msg.value0)), info(" look vacant, as he starts to stumble around!") ];
        };
        if (msg instanceof Ritoppu_Action.NoStairs) {
            return [ debug("There are no stairs here.") ];
        };
        if (msg instanceof Ritoppu_Action.DownstairsRest) {
            return [ focus("You take a moment to rest, and recover your strength.") ];
        };
        if (msg instanceof Ritoppu_Action.TakeOn) {
            return [ info("You equipped the "), focus(msg.value0) ];
        };
        if (msg instanceof Ritoppu_Action.TookOff) {
            return [ info("You dequipped the "), focus(msg.value0) ];
        };
        throw new Error("Failed pattern match at Ritoppu.DisplayLog (line 21, column 40 - line 94, column 49): " + [ msg.constructor.name ]);
    })());
};
var loggerBlock = function (logs) {
    return div("logger-block")(Data_Functor.map(Data_Functor.functorArray)(buildMessage)(logs));
};
module.exports = {
    loggerBlock: loggerBlock
};
